module.exports = __webpack_public_path__ + "media/bootstrap-icons/card-image-f775f845.svg";